import React, { useEffect, useRef } from "react";
import L from "leaflet";

// Custom terracotta teardrop pin
function pinIcon(active) {
  return L.divIcon({
    className: "",
    html: `<div class="nd-pin ${active ? "active" : ""}"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg></div>`,
    iconSize: [30, 30],
    iconAnchor: [15, 28],
  });
}

export default function Map({ center, shops = [], activeId, onSelect }) {
  const mapRef = useRef(null);
  const containerRef = useRef(null);
  const markersRef = useRef({});

  useEffect(() => {
    if (mapRef.current || !containerRef.current) return;
    const map = L.map(containerRef.current, {
      center: [center.lat, center.lng],
      zoom: 14,
      zoomControl: true,
      scrollWheelZoom: true,
      attributionControl: false,
    });
    L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png", {
      maxZoom: 19,
    }).addTo(map);
    mapRef.current = map;
    return () => {
      map.remove();
      mapRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Recenter
  useEffect(() => {
    if (mapRef.current) mapRef.current.setView([center.lat, center.lng], mapRef.current.getZoom());
  }, [center.lat, center.lng]);

  // Render markers
  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    Object.values(markersRef.current).forEach((m) => m.remove());
    markersRef.current = {};
    shops.forEach((s) => {
      const marker = L.marker([s.lat, s.lng], { icon: pinIcon(s.id === activeId) }).addTo(map);
      marker.on("click", () => onSelect && onSelect(s.id));
      marker.bindTooltip(s.name, { direction: "top", offset: [0, -26] });
      markersRef.current[s.id] = marker;
    });
  }, [shops, activeId, onSelect]);

  return <div ref={containerRef} data-testid="browse-map" className="w-full h-full" />;
}
